import { useCallback, useState, useRef } from 'react';
import Text from 'presentation/components/text/index.js';
import Tooltip from 'presentation/components/tooltip/index.js';
import Button from 'presentation/components/button/index.js';
import Image from 'presentation/components/image/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import { isEmpty } from 'mojito/utils';

const LabeledTooltip = props => {
    const {
        mojitoTools,
        title,
        additionalInfo,
        tooltipText,
        tooltipButtonText,
        showTooltipButton,
        onTooltipButtonClick,
        disabled,
    } = props;
    const { config, style } = mojitoTools;
    const buttonRef = useRef();
    const [showTooltip, setShowTooltip] = useState(false);
    const hideTooltip = useCallback(() => setShowTooltip(false), [setShowTooltip]);
    const onClickOutside = useCallback(
        event => {
            const element = buttonRef.current;
            const clickTarget = event.target;
            // Only hide tooltip if click was done somewhere outside labeled tooltip element.
            if (clickTarget !== element && !element.contains(clickTarget)) {
                hideTooltip();
            }
        },
        [hideTooltip]
    );
    const onTooltipClick = config.closeOnTooltipClick ? hideTooltip : undefined;
    const hasIcon = !isEmpty(config.icon.src);
    const { disableTooltip } = config;

    const isDisableTooltip = disabled || disableTooltip || isEmpty(tooltipText);

    return (
        <Button
            buttonElementRef={buttonRef}
            config={config.clickableArea}
            onClick={() => setShowTooltip(true)}
            class="ta-LabeledTooltip"
            disabled={isDisableTooltip}
        >
            <FlexPane config={disabled ? style.labelContainerDisabled : config.labelContainer}>
                {hasIcon && <Image config={config.icon} class="ta-LabledTooltipIcon" />}
                {title && (
                    <Text config={config.title} class="ta-LabledTooltipLabel">
                        {title}
                    </Text>
                )}
                {additionalInfo && (
                    <Text config={config.additionalInfo} class="ta-LabledTooltipAdditionalInfo">
                        {additionalInfo}
                    </Text>
                )}
            </FlexPane>
            {showTooltip && (
                <Tooltip
                    onClick={onTooltipClick}
                    onClose={hideTooltip}
                    onOutsideClick={onClickOutside}
                    text={tooltipText}
                    linkText={tooltipButtonText}
                    showTooltipButton={showTooltipButton}
                    onLinkClick={onTooltipButtonClick}
                    config={config.tooltip}
                />
            )}
        </Button>
    );
};

LabeledTooltip.getStyle = (config, mode, merge) => {
    return {
        labelContainerDisabled: merge(config.labelContainer, config.labelContainerDisabled),
    };
};

export default LabeledTooltip;
